import React from 'react';
import { observer } from "mobx-react-lite";
import { StringActionDetail } from './components/StringActionDetail';
import { AnimationElementValueModel, AreaTriggerValueModel, EnemyOnMapValueModel, ExtendedMapMarkerValueModel, FactionValueModel, InteractionTriggerValueModel, ItemIdValueModel, ItemTagValueModel, MapMarkerValueModel, NPCOnMapValueModel, NPCValueModel, NumberValueModel, PlayStyleValueModel, QuestIdValueModel, SoundValueModel, StringValueModel, TranslatedStringValueModel } from '../../../../shared/action/ValueModel';
import { useTranslation } from 'react-i18next';
import { clone } from 'mobx-keystone';
import { DisplayMode, TranslatedStringActionDetail } from './components/TranslatedStringActionDetail';
import { BooleanActionDetail } from './components/BooleanActionDetail';
import { TreeParameterActionAnimationElementValueExtraDetails } from './TreeParameterActionAnimationElementValueExtraDetails';
import { ElementGroup, ElementLabel } from './components/BaseElements';
const valueModelTypes = [new TranslatedStringValueModel({}), new ItemIdValueModel({}), new ItemTagValueModel({}), new NPCValueModel({}), new NPCOnMapValueModel({}), new EnemyOnMapValueModel({}), new AnimationElementValueModel({}), new FactionValueModel({}), new MapMarkerValueModel({}), new ExtendedMapMarkerValueModel({}), new AreaTriggerValueModel({}), new InteractionTriggerValueModel({}), new PlayStyleValueModel({}), new QuestIdValueModel({}), new StringValueModel({}), new NumberValueModel({}), new SoundValueModel({})];
const valueModelPrototypes = valueModelTypes.reduce((obj, key) => {
  obj[key.$modelType] = key;
  return obj;
}, {});
export const TreeParameterActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_name"),
    value: action.name,
    valueSetter: action.setName.bind(action),
    allowBlankValue: false
  }), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t("action_editor.property_type")), /*#__PURE__*/React.createElement("select", {
    value: action.value.$modelType,
    onChange: ({
      target
    }) => action.setValue(clone(valueModelPrototypes[target.value]))
  }, valueModelTypes.map(valueModel => /*#__PURE__*/React.createElement("option", {
    key: valueModel.$modelType,
    value: valueModel.$modelType
  }, t(valueModel.title()))))), action.value instanceof AnimationElementValueModel && /*#__PURE__*/React.createElement(TreeParameterActionAnimationElementValueExtraDetails, {
    valueInstance: action.value
  }), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_outside_label"),
    translatedString: action.description,
    displayMode: DisplayMode.Simple,
    allowBlankValue: true
  }), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_tutorial"),
    translatedString: action.tutorial,
    displayMode: DisplayMode.Simple,
    allowBlankValue: true
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_dividing_line"),
    checked: action.dividingLine,
    toggle: action.toggleDividingLine.bind(action)
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_show_on_node"),
    checked: action.showOnNode,
    toggle: action.toggleShowOnNode.bind(action)
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.allow_blank_value"),
    checked: action.allowBlankValue,
    toggle: action.toggleAllowBlankValue.bind(action)
  }));
});